export const baseApiPath = (eventType) => {
  if (!eventType) {
    return ''
  }

  const { type, ownerType, ownerId } = eventType
  if (type === 'ManagedEventType') {
    return '/api/organization/managed_event_types'
  }

  if (ownerType === 'Organization') {
    return '/api/organization/event_types'
  }

  if (ownerType === 'Page') {
    return `/api/pages/${ownerId}/event_types`
  }

  return `/api/users/${ownerId || 'me'}/event_types`
}

export const basePath = (eventType) => baseApiPath({
  type: eventType.type,
  ownerType: eventType.owner_type || eventType.ownerType,
  ownerId: eventType?.owner_id || eventType?.ownerId || eventType?.profile?.owner_id
})

export const memberPath = (eventType) => `${basePath(eventType)}/${eventType.id}`
